import api from "@/api";

import {
  GET_MANAGE_ORGANIZATION_INFO,
} from "./types";

export default {
  [GET_MANAGE_ORGANIZATION_INFO]: async ({ commit, getters }, premiseId) => {
    const { getPersonalAccountInfo } = getters;
    if (!premiseId) premiseId = getPersonalAccountInfo.apartment.premiseId;

    const resp = await api.main.getManageOrganizationInfo(premiseId);
    commit(GET_MANAGE_ORGANIZATION_INFO, await resp.data);
    return resp.data;
  },
};
